import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/quienes-somos',
        name: 'QuienesSomos',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/QuienesSomos.vue')
    },
    {
        path: '/nuestras-marcas',
        name: 'NuestrasMarcas',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/NuestrasMarcas.vue')
    },
    {
        path: '/responsabilidad-social',
        name: 'ResponsabilidadSocial',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/ResponsabilidadSocial.vue')
    },
    {
        path: '/nuestra-gente',
        name: 'NuestraGente',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/NuestraGente.vue')
    },
    {
        path: '/cedis',
        name: 'Cedis',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Cedis.vue')
    },
    {
        path: '/contacto',
        name: 'Contacto',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Contacto.vue')
    },
    {
        path: '/vacantes',
        name: 'Vacantes',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Vacantes.vue')
    },
    {
        path: '/vacantes-copypruebas',
        name: 'Vacantes-copypruebas',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Vacantes-copypruebas.vue')
    },
    {
        path: '/preguntasFrecuentes',
        name: 'PreguntasFrecuentes',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/PreguntasFrecuentes.vue')
    },
    {
        path: '/prensa',
        name: 'Prensa',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Prensa.vue')
    },
    {
        path: '/noticias',
        name: 'Noticias',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Noticias.vue')
    },
    {
        path: '/lineaetica',
        name: 'Lineaetica',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "denuncias" */ '../views/Lineaetica.vue')
    },
    {
        path: '/AvisoPrivacidad',
        name: 'AvisoPrivacidad',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "denuncias" */ '../views/AvisoPrivacidad.vue')
    },
    {
        path: '/noticia/:nombre_entrada',
        name: 'Noticia',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "noticia" */ '../views/Noticia.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // scrollBehavior() {
    //     window.scrollTo(0, 0);
    // }
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;

        }

        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
            }
        }
        return { x: 0, y: 0 }
    },
})

export default router